import { render } from "./QrCode.vue?vue&type=template&id=1018f8b0&scoped=true"
import script from "./QrCode.vue?vue&type=script&lang=js"
export * from "./QrCode.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=1018f8b0&scoped=true&lang=css"
import "@/assets/css/user/pages/payment.css?vue&type=style&index=1&id=1018f8b0&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=2&id=1018f8b0&scoped=true&lang=css"
import "@/assets/css/user/dark/payment-dark.css?vue&type=style&index=3&id=1018f8b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1018f8b0"]])

export default __exports__